import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Loader } from 'rsuite';

const SessionTimeoutModal = ({ show, onStayConnected, onLogout, isLoading }) => (
  <Modal show={show} backdrop="static" keyboard={false}>
    <Modal.Header closeButton={false}>
      <Modal.Title>Session Expiring Soon</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>Your session will expire soon due to inactivity.</p>
      <p>Would you like to stay signed in?</p>
      {isLoading && (
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <Loader content="Refreshing session..." />
        </div>
      )}
    </Modal.Body>
    <Modal.Footer
      style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
      }}
    >
      <Button
        appearance="primary"
        onClick={onStayConnected}
        style={{ minWidth: 140 }}
        disabled={isLoading}
        loading={isLoading}
      >
        Stay Signed In
      </Button>
      <Button appearance="subtle" onClick={onLogout} disabled={isLoading}>
        Sign Out
      </Button>
    </Modal.Footer>
  </Modal>
);

SessionTimeoutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onStayConnected: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

SessionTimeoutModal.defaultProps = {
  isLoading: false,
};

export default SessionTimeoutModal;



// WEBPACK FOOTER //
// ./src/components/SessionTimeoutModal/SessionTimeoutModal.jsx